// onboardingFunnelState.js — onboarding funnel telemetry guards
//
// Deterministic, storage-injected helpers so funnel events fire at the correct
// multiplicity without over-counting:
//   • markOnce(store, key) — fire-once semantics (first property search per
//     session; onboarding-completed once per user).
//   • incrementSessionCount(store, uid) / isReturnSession(count) — detect the
//     user's 2nd distinct session for the `second_session` return-usage signal.
//
// Fail-safe: a missing or throwing store never blocks the app (returns
// false / 0). Call sites pass window.sessionStorage / window.localStorage.

export function markOnce(store, key) {
  if (!store || !key) return false;
  try {
    if (store.getItem(key)) return false;
    store.setItem(key, "1");
    return true;
  } catch {
    return false;
  }
}

export function incrementSessionCount(store, uid) {
  if (!store || !uid) return 0;
  try {
    const key = `rentava_session_count_${uid}`;
    const next = (parseInt(store.getItem(key) || "0", 10) || 0) + 1;
    store.setItem(key, String(next));
    return next;
  } catch {
    return 0;
  }
}

// The user's 2nd session is the return-usage milestone (fires exactly once).
export function isReturnSession(count) {
  return count === 2;
}
